import styled from 'styled-components';

export const ReviewCardsCompatibilityStyles = styled.div`
  margin-top: 20px;

  .review-cards-swiper {
    width: 100%;
    overflow: visible;
    padding-left: 16px;
    padding-right: 16px;

    .swiper-wrapper {
      align-items: stretch;
    }
  }

  .review-card {
    width: 320px;
    flex-shrink: 0;
    display: flex;
    height: auto;

    &-content {
      padding: 16px;
      background: rgba(128, 62, 255, 0.07);
      position: relative;
      border-radius: 8px;
      min-height: 190px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      width: 100%;
    }

    @media screen and (min-width: 576px) {
      width: 320px;
    }

    .review-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 12px;

      .user-info {
        display: flex;
        align-items: center;
        gap: 8px;

        .country {
          font-size: 16px;
        }
      }
    }

    .stars {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 6px;
      margin-bottom: 12px;
    }

    .review-text {
      margin-bottom: 8px;
    }

    .review-source {
      margin-top: auto;
      opacity: 0.6;
    }
  }
`;
